import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../../lib/config';
import {
  ChevronLeftIcon,
  UserGroupIcon
} from '@heroicons/react/24/outline';

const API = API_BASE;

const JoinTeam = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const ENABLE_CMS = process.env.REACT_APP_ENABLE_CMS === '1';
  const LINE_OFFICIAL_URL = process.env.REACT_APP_LINE_OFFICIAL_URL || process.env.NEXT_PUBLIC_LINE_OFFICIAL_URL || '';

  useEffect(() => {
    if (!ENABLE_CMS) { setLoading(false); return; }
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await fetch(`${API}/content/join-team`);
      if (response.ok) {
        const data = await response.json();
        setContent(data);
      }
    } catch (error) {
      console.error('Error fetching join team content:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">読み込み中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <button
              onClick={() => navigate('/mypage')}
              className="mr-4 p-2 text-gray-600 hover:text-gray-900"
            >
              <ChevronLeftIcon className="w-6 h-6" />
            </button>
            <h1 className="text-xl font-bold text-gray-900">
              {(ENABLE_CMS && content?.title) || 'バイターズを一緒につくりませんか？'}
            </h1>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="text-center mb-8">
            <UserGroupIcon className="w-12 h-12 text-blue-600 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {(ENABLE_CMS && content?.title) || 'バイターズを一緒につくりませんか？'}
            </h2>
            {!ENABLE_CMS && (
              <p className="text-gray-600">最終更新日：未設定</p>
            )}
          </div>

          <div className="prose max-w-none">
            {(ENABLE_CMS && content?.content) ? (
              <div
                dangerouslySetInnerHTML={{ __html: content.content.replace(/\n/g, '<br>') }}
                className="text-gray-700 leading-relaxed whitespace-pre-wrap"
              />
            ) : (
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p>バイターズのプロダクト/運営を一緒に作っていただける仲間を募集しています。プロダクト開発、デザイン、カスタマーサポート、事業開発など、幅広い領域で参画いただけます。</p>
                <ul className="list-disc pl-6">
                  <li>短時間・副業からの参画歓迎</li>
                  <li>フルリモート可</li>
                  <li>ユーザー体験を第一に考えられる方</li>
                </ul>
                <p>ご関心のある方は、マイページのお問い合わせからご連絡ください。一緒により良い体験を届けましょう。</p>
              </div>
            )}
          </div>

          {/* Contact CTA */}
          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
            {LINE_OFFICIAL_URL ? (
              <a
                href={LINE_OFFICIAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 rounded-lg text-white font-medium"
                style={{ backgroundColor: '#06C755' }}
              >
                LINEで問い合わせる
              </a>
            ) : (
              <button
                onClick={() => navigate('/mypage/contact')}
                className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium"
              >
                問い合わせフォームへ
              </button>
            )}
            <button
              onClick={() => navigate('/mypage')}
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              マイページに戻る
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinTeam;